import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../../Confirmation'
import { getListingPortalLabel } from '../../../RentalPortalListing'
import { QA_NAME_INTEGRATIONS_CONNECT } from '../RentalPortalIntegrations.constants'

function IntegrationsOauthConnectModal({
  isSaving,
  portal,
  onCancel,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('RentalPortal.IntegrationsConnectBtnKey'),
      }}
      description={t('RentalPortal.IntegrationsConnectOauthTextKey', {
        portal: getListingPortalLabel(portal),
      })}
      loading={isSaving}
      qaName={QA_NAME_INTEGRATIONS_CONNECT}
      title={t('RentalPortal.IntegrationsConnectTitleKey', {
        portal: getListingPortalLabel(portal),
      })}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  )
}

export default IntegrationsOauthConnectModal
